import { initializeApp } from "firebase/app";
import { getAuth, browserLocalPersistence, setPersistence  } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN, 
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_APPID,
  clientId: process.env.REACT_APP_CLIENT_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
  
 
// IMPORTANT FIX FOR IOS
setPersistence(auth, browserLocalPersistence).catch(console.error);